"use client";

import React from "react";
import { ButtonPrimary } from "@/components/common/StandardButton";
import StandardCard from "../common/StandardCard";

interface OrderSetSupportCardProps {
  orderId: string;
  orderSetId: string;
}

const OrderSetSupportCard: React.FC<OrderSetSupportCardProps> = ({
  orderId,
  orderSetId,
}) => {
  return (
    <StandardCard
      title="Support"
      headerAction={<ButtonPrimary size="sm">+ Create</ButtonPrimary>}
    >
      <div className="text-center py-8">
        <div className="text-sm text-muted-foreground mb-2">
          No support tickets for this order set
        </div>
        <div className="text-xs text-muted-foreground">
          Create a support ticket for order set issues
        </div>
        <div className="text-xs text-muted-foreground mt-1">
          Order #{orderId.slice(-6)} | Set #{orderSetId.slice(-6)}
        </div>
      </div>
    </StandardCard>
  );
};

export default OrderSetSupportCard;
